import log from 'salvo-lite/log'
import EventBus from '../helpers/event-bus'
import axios from 'axios'
class Cart {
    constructor (components) {
        this._name = this.constructor.name
        this._components = components

        this._selectors = {
            container: '[js-cart="container"]',
            form: '.template-cart__container',
            input_fiscal: '#fiscal-code',
            input_vin_reg: '#vin-reg',
            errors: '.error'
        }

        this._cartForm = document.querySelector(this._selectors.form)

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        /**
        * Global Frame utils
        */
        window.Frame = window.Frame || {}
        window.Frame.EventBus = EventBus()

        window.Frame.EventBus.listen('AjaxCart:cartEmpty', () => {
            document.querySelector(this._selectors.container).innerHTML = `
              <div class="template-cart__empty">
                <div class="row no-margin">
                  <div class="col s12 m6 offset-m3 text-center">
                    <h1>${window.theme.strings.cart.general.title}</h1>
                    <p>${window.theme.strings.cart.general.empty}</p>
                    <a href="/collections/all" class="button button--primary button--small">${window.theme.strings.cart.general.continueBrowsing}</a>
                  </div>
                </div>
              </div>
            `
        })

        if (this._cartForm) {
            this._cartForm.addEventListener('submit', (event) => {
                this._validateForm(event)
            })
        }
    }

    async _validateForm (event) {
        event.preventDefault()

        this._removeValidationErrors()

        const errors = []

        const inputVinReg = event.target.querySelector(this._selectors.input_vin_reg)
        if (inputVinReg) {
            if (inputVinReg.value === '') {
                errors.push({
                    field: this._selectors.input_vin_reg,
                    error: inputVinReg.dataset.validationValue
                })
            } else if (inputVinReg.value.length < 17) {
                // This error also needs to show how
                // many characters were entered
                let errorMessage = inputVinReg.dataset.validationLength
                if (errorMessage.includes('#')) {
                    errorMessage = errorMessage.replace('#', inputVinReg.value.length)
                }
                errors.push({
                    field: this._selectors.input_vin_reg,
                    error: errorMessage
                })
            } else if (inputVinReg.value.length > 17) {
                // This error also needs to show how
                // many characters were entered
                let errorMessage = inputVinReg.dataset.validationLength
                if (errorMessage.includes('#')) {
                    errorMessage = errorMessage.replace('#', inputVinReg.value.length)
                }
                errors.push({
                    field: this._selectors.input_vin_reg,
                    error: errorMessage
                })
            } else {
                try {
                    const payload = {
                        attributes: {
                            'FCJ VIN': inputVinReg.value
                        }
                    }

                    await axios.post('/cart/update.json', payload)
                } catch (error) {
                    console.log(error)
                    errors.push({
                        field: this._selectors.input_vin_reg,
                        error: inputVinReg.dataset.validationError
                    })
                }
            }
        }

        // If there are errors, display them
        // and bail early
        if (errors.length) {
            this._showValidationErrors(errors)
            this._scrollToFirstError()
            return
        }

        // No errors, off you go
        this._cartForm.submit()
    }

    _showValidationErrors (errors) {
        errors.forEach((errorObject) => {
            const inputField = document.querySelector(errorObject.field)
            const inputGroup = inputField.closest('.esc-input-group')
            const errorElement = inputGroup.querySelector('.error')
            inputField.setAttribute('aria-invalid', true)
            errorElement.innerText = errorObject.error
            errorElement.classList.add('is-active')
            errorElement.setAttribute('aria-hidden', false)
        })
    }

    _removeValidationErrors () {
        const errors = document.querySelectorAll(this._selectors.errors)
        errors.forEach((element) => {
            element.classList.remove('is-active')
            element.setAttribute('aria-hidden', true)
        })
    }

    _scrollToFirstError () {
        const firstError = document.querySelector('.error.is-active')
        firstError.scrollIntoView()
    }
}

export default Cart



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Cart.js